"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1344],{

/***/ 40848:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * HC-Sticky
 * =========
 * Version: 2.2.7
 * Author: Some Web Media
 * Author URL: https://github.com/somewebmedia
 * Plugin URL: https://github.com/somewebmedia/hc-sticky
 * Description: JavaScript library that makes any element on your page visible while you scroll
 * License: MIT
 */
!function(t,e){if( true&&"object"==typeof module.exports){if(!t.document)throw new Error("HC-Sticky requires a browser to run.");module.exports=e(t)}else true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e(t)),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0}("undefined"!=typeof window?window:this,function(V){var i,n,Q=V.document,U={top:0,bottom:0,bottomEnd:0,innerTop:0,innerSticker:null,stickyClass:"sticky",stickTo:null,followScroll:!0,responsive:null,mobileFirst:!1,onStart:null,onStop:null,onBeforeResize:null,onResize:null,resizeDebounce:100,disable:!1},Y=function(t,e,o){console.warn("%cHC Sticky:%c "+o+"%c '"+t+"'%c is now deprecated and will be removed. Use%c '"+e+"'%c instead.","color: #fa253b","color: default","color: #5595c6","color: default","color: #5595c6","color: default")},$=function(n,f){var o=this;if(f=f||{},!(n="string"==typeof n?Q.querySelector(n):n))return!1;f.queries&&Y("queries","responsive","option"),f.queryFlow&&Y("queryFlow","mobileFirst","option");var p={},u=$.Helpers,s=n.parentNode;"static"===u.getStyle(s,"position")&&(s.style.position="relative");function d(t){u.isEmptyObject(t=t||{})&&!u.isEmptyObject(p)||(p=Object.assign({},U,p,t))}function t(){return p.disable}function e(){var t,e=p.responsive||p.queries;if(e){var o=V.innerWidth;if(t=f,(p=Object.assign({},U,t||{})).mobileFirst)for(var i in e)i<=o&&!u.isEmptyObject(e[i])&&d(e[i]);else{var n,s=[];for(n in e){var r={};r[n]=e[n],s.push(r)}for(var l=s.length-1;0<=l;l--){var a=s[l],c=Object.keys(a)[0];o<=c&&!u.isEmptyObject(a[c])&&d(a[c])}}}}function i(){var t,e,o,i;I.css=(t=n,e=u.getCascadedStyle(t),o=u.getStyle(t),i={height:t.offsetHeight+"px",left:e.left,right:e.right,top:e.top,bottom:e.bottom,position:o.position,display:o.display,verticalAlign:o.verticalAlign,boxSizing:o.boxSizing,marginLeft:e.marginLeft,marginRight:e.marginRight,marginTop:e.marginTop,marginBottom:e.marginBottom,paddingLeft:e.paddingLeft,paddingRight:e.paddingRight},e.float&&(i.float=e.float||"none"),e.cssFloat&&(i.cssFloat=e.cssFloat||"none"),o.MozBoxSizing&&(i.MozBoxSizing=o.MozBoxSizing),i.width="auto"!==e.width?e.width:"border-box"===i.boxSizing||"border-box"===i.MozBoxSizing?t.offsetWidth+"px":o.width,i),P.init(),y=!(!p.stickTo||!("document"===p.stickTo||p.stickTo.nodeType&&9===p.stickTo.nodeType||"object"==typeof p.stickTo&&p.stickTo instanceof("undefined"!=typeof HTMLDocument?HTMLDocument:Document))),h=p.stickTo?y?Q:u.getElement(p.stickTo):s,z=(R=function(){var t=n.offsetHeight+(parseInt(I.css.marginTop)||0)+(parseInt(I.css.marginBottom)||0),e=(z||0)-t;return-1<=e&&e<=1?z:t})(),v=(H=function(){return y?Math.max(Q.documentElement.clientHeight,Q.body.scrollHeight,Q.documentElement.scrollHeight,Q.body.offsetHeight,Q.documentElement.offsetHeight):h.offsetHeight})(),S=y?0:u.offset(h).top,w=p.stickTo?y?0:u.offset(s).top:S,E=V.innerHeight,N=n.offsetTop-(parseInt(I.css.marginTop)||0),b=u.getElement(p.innerSticker),L=isNaN(p.top)&&-1<p.top.indexOf("%")?parseFloat(p.top)/100*E:p.top,k=isNaN(p.bottom)&&-1<p.bottom.indexOf("%")?parseFloat(p.bottom)/100*E:p.bottom,x=b?b.offsetTop:p.innerTop||0,T=isNaN(p.bottomEnd)&&-1<p.bottomEnd.indexOf("%")?parseFloat(p.bottomEnd)/100*E:p.bottomEnd,j=S-L+x+N}function r(){z=R(),v=H(),O=S+v-L-T,C=E<z;var t,e=V.pageYOffset||Q.documentElement.scrollTop,o=u.offset(n).top,i=o-e;B=e<F?"up":"down",A=e-F,j<(F=e)?O+L+(C?k:0)-(p.followScroll&&C?0:L)<=e+z-x-(E-(j-x)<z-x&&p.followScroll&&0<(t=z-E-x)?t:0)?I.release({position:"absolute",bottom:w+s.offsetHeight-O-L}):C&&p.followScroll?"down"==B?i+z+k<=E+.9?I.stick({bottom:k}):"fixed"===I.position&&I.release({position:"absolute",top:o-L-j-A+x}):Math.ceil(i+x)<0&&"fixed"===I.position?I.release({position:"absolute",top:o-L-j+x-A}):e+L-x<=o&&I.stick({top:L-x}):I.stick({top:L-x}):I.release({stop:!0})}function l(){M&&(V.removeEventListener("scroll",r,u.supportsPassive),M=!1)}function a(){null!==n.offsetParent&&"none"!==u.getStyle(n,"display")?(i(),v<z?l():(r(),M||(V.addEventListener("scroll",r,u.supportsPassive),M=!0))):l()}function c(){n.style.position="",n.style.left="",n.style.top="",n.style.bottom="",n.style.width="",n.classList?n.classList.remove(p.stickyClass):n.className=n.className.replace(new RegExp("(^|\\b)"+p.stickyClass.split(" ").join("|")+"(\\b|$)","gi")," "),I.css={},!(I.position=null)===P.isAttached&&P.detach()}function g(){c(),e(),(t()?l:a)()}function m(){q&&(V.removeEventListener("resize",W,u.supportsPassive),q=!1),l()}var y,h,b,v,S,w,E,L,k,x,T,j,O,C,z,N,H,R,A,B,I={css:{},position:null,stick:function(t){t=t||{},u.hasClass(n,p.stickyClass)||(!1===P.isAttached&&P.attach(),I.position="fixed",n.style.position="fixed",n.style.left=P.offsetLeft+"px",n.style.width=P.width,void 0===t.bottom?n.style.bottom="auto":n.style.bottom=t.bottom+"px",void 0===t.top?n.style.top="auto":n.style.top=t.top+"px",n.classList?n.classList.add(p.stickyClass):n.className+=" "+p.stickyClass,p.onStart&&p.onStart.call(n,Object.assign({},p)))},release:function(t){var e;(t=t||{}).stop=t.stop||!1,!0!==t.stop&&"fixed"!==I.position&&null!==I.position&&(void 0===t.top&&void 0===t.bottom||void 0!==t.top&&(parseInt(u.getStyle(n,"top"))||0)===t.top||void 0!==t.bottom&&(parseInt(u.getStyle(n,"bottom"))||0)===t.bottom)||(!0===t.stop?!0===P.isAttached&&P.detach():!1===P.isAttached&&P.attach(),e=t.position||I.css.position,I.position=e,n.style.position=e,n.style.left=!0===t.stop?I.css.left:P.positionLeft+"px",n.style.width=("absolute"!==e?I.css:P).width,void 0===t.bottom?n.style.bottom=!0===t.stop?"":"auto":n.style.bottom=t.bottom+"px",void 0===t.top?n.style.top=!0===t.stop?"":"auto":n.style.top=t.top+"px",n.classList?n.classList.remove(p.stickyClass):n.className=n.className.replace(new RegExp("(^|\\b)"+p.stickyClass.split(" ").join("|")+"(\\b|$)","gi")," "),p.onStop&&p.onStop.call(n,Object.assign({},p)))}},P={el:Q.createElement("div"),offsetLeft:null,positionLeft:null,width:null,isAttached:!1,init:function(){for(var t in P.el.className="sticky-spacer",I.css)P.el.style[t]=I.css[t];P.el.style["z-index"]="-1";var e=u.getStyle(n);P.offsetLeft=u.offset(n).left-(parseInt(e.marginLeft)||0),P.positionLeft=u.position(n).left,P.width=u.getStyle(n,"width")},attach:function(){s.insertBefore(P.el,n),P.isAttached=!0},detach:function(){P.el=s.removeChild(P.el),P.isAttached=!1}},F=V.pageYOffset||Q.documentElement.scrollTop,M=!1,q=!1,D=function(){p.onBeforeResize&&p.onBeforeResize.call(n,Object.assign({},p)),g(),p.onResize&&p.onResize.call(n,Object.assign({},p))},W=p.resizeDebounce?u.debounce(D,p.resizeDebounce):D,D=function(){q||(V.addEventListener("resize",W,u.supportsPassive),q=!0),e(),(t()?l:a)()};this.options=function(t){return t?p[t]:Object.assign({},p)},this.refresh=g,this.update=function(t){d(t),f=Object.assign({},f,t||{}),g()},this.attach=D,this.detach=m,this.destroy=function(){m(),c()},this.triggerMethod=function(t,e){"function"==typeof o[t]&&o[t](e)},this.reinit=function(){Y("reinit","refresh","method"),g()},d(f),D(),V.addEventListener("load",g)};return void 0!==V.jQuery&&(i=V.jQuery,n="hcSticky",i.fn.extend({hcSticky:function(e,o){return this.length?"options"===e?i.data(this.get(0),n).options():this.each(function(){var t=i.data(this,n);t?t.triggerMethod(e,o):(t=new $(this,e),i.data(this,n,t))}):this}})),V.hcSticky=V.hcSticky||$,$}),function(a){var t=a.hcSticky,c=a.document;"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(t,e){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var o=Object(t),i=1;i<arguments.length;i++){var n=arguments[i];if(null!=n)for(var s in n)Object.prototype.hasOwnProperty.call(n,s)&&(o[s]=n[s])}return o},writable:!0,configurable:!0}),Array.prototype.forEach||(Array.prototype.forEach=function(t){var e,o;if(null==this)throw new TypeError("this is null or not defined");var i,n=Object(this),s=n.length>>>0;if("function"!=typeof t)throw new TypeError(t+" is not a function");for(1<arguments.length&&(e=arguments[1]),o=0;o<s;)o in n&&(i=n[o],t.call(e,i,o,n)),o++});var e=!1;try{var o=Object.defineProperty({},"passive",{get:function(){e={passive:!1}}});a.addEventListener("testPassive",null,o),a.removeEventListener("testPassive",null,o)}catch(t){}function n(t,e){return a.getComputedStyle?e?c.defaultView.getComputedStyle(t,null).getPropertyValue(e):c.defaultView.getComputedStyle(t,null):t.currentStyle?e?t.currentStyle[e.replace(/-\w/g,function(t){return t.toUpperCase().replace("-","")})]:t.currentStyle:void 0}function s(t){var e=t.getBoundingClientRect(),o=a.pageYOffset||c.documentElement.scrollTop,t=a.pageXOffset||c.documentElement.scrollLeft;return{top:e.top+o,left:e.left+t}}t.Helpers={supportsPassive:e,isEmptyObject:function(t){for(var e in t)return!1;return!0},debounce:function(i,n,s){var r;return function(){var t=this,e=arguments,o=s&&!r;clearTimeout(r),r=setTimeout(function(){r=null,s||i.apply(t,e)},n),o&&i.apply(t,e)}},hasClass:function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)},offset:s,position:function(t){var e=t.offsetParent,o=s(e),i=s(t),e=n(e),t=n(t);return o.top+=parseInt(e.borderTopWidth)||0,o.left+=parseInt(e.borderLeftWidth)||0,{top:i.top-o.top-(parseInt(t.marginTop)||0),left:i.left-o.left-(parseInt(t.marginLeft)||0)}},getElement:function(t){var e=null;return"string"==typeof t?e=c.querySelector(t):a.jQuery&&t instanceof a.jQuery&&t.length?e=t[0]:t instanceof Element&&(e=t),e},getStyle:n,getCascadedStyle:function(t){var e,o=t.cloneNode(!0);o.style.display="none",Array.prototype.slice.call(o.querySelectorAll('input[type="radio"]')).forEach(function(t){t.removeAttribute("name")}),t.parentNode.insertBefore(o,t.nextSibling),o.currentStyle?e=o.currentStyle:a.getComputedStyle&&(e=c.defaultView.getComputedStyle(o,null));var i,n,s,r={};for(i in e)!isNaN(i)||"string"!=typeof e[i]&&"number"!=typeof e[i]||(r[i]=e[i]);if(Object.keys(r).length<3)for(var l in r={},e)isNaN(l)||(r[e[l].replace(/-\w/g,function(t){return t.toUpperCase().replace("-","")})]=e.getPropertyValue(e[l]));return r.margin||"auto"!==r.marginLeft?r.margin||r.marginLeft!==r.marginRight||r.marginLeft!==r.marginTop||r.marginLeft!==r.marginBottom||(r.margin=r.marginLeft):r.margin="auto",r.margin||"0px"!==r.marginLeft||"0px"!==r.marginRight||(s=(n=t.offsetLeft-t.parentNode.offsetLeft)-(parseInt(r.left)||0)-(parseInt(r.right)||0),0!=(s=t.parentNode.offsetWidth-t.offsetWidth-n-(parseInt(r.right)||0)+(parseInt(r.left)||0)-s)&&1!=s||(r.margin="auto")),o.parentNode.removeChild(o),o=null,r}}}(window);

/***/ }),

/***/ 71368:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
!function(s) {
    "use strict";
    var e = function e(s) {
        return new RegExp("(^|\\s+)" + s + "(\\s+|$)");
    };
    var n = function n(s, e) {
        var n1 = t(s, e) ? c : a;
        n1(s, e);
    };
    var t, a, c;
    "classList" in document.documentElement ? (t = function t(s, e) {
        return s.classList.contains(e);
    }, a = function a(s, e) {
        s.classList.add(e);
    }, c = function c(s, e) {
        s.classList.remove(e);
    }) : (t = function t(s, n) {
        return e(n).test(s.className);
    }, a = function a(s, e) {
        t(s, e) || (s.className = s.className + " " + e);
    }, c = function c(s, n) {
        s.className = s.className.replace(e(n), " ");
    });
    var o = {
        hasClass: t,
        addClass: a,
        removeClass: c,
        toggleClass: n,
        has: t,
        add: a,
        remove: c,
        toggle: n
    };
     true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (o),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
}(window);


/***/ }),

/***/ 81344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ IndexScripts; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/jquery/dist/jquery.min.js
var jquery_min = __webpack_require__(97452);
var jquery_min_default = /*#__PURE__*/__webpack_require__.n(jquery_min);
// EXTERNAL MODULE: ./assets/plugins/classie/1.0.1/classie.min.js
var classie_min = __webpack_require__(71368);
var classie_min_default = /*#__PURE__*/__webpack_require__.n(classie_min);
;// CONCATENATED MODULE: ./assets/js/property.min.js

var hcSticky = __webpack_require__(40848);

jquery_min_default()(document).ready(function(f) {
    var $stickyBookNow = jquery_min_default()("#sticky_book_now");
    if ($stickyBookNow.length > 0) {
        var top = parseInt($stickyBookNow.css("margin-bottom").split("px")[0]);
        var sticky = jquery_min_default().fn.initHcSticky("#sticky_book_now", top);
        var init = false;
        jquery_min_default()(window).on("scroll", function(e) {
            var $data_init_responsive_tabs = jquery_min_default()('[data-init-reponsive-tabs="dropdownfx"]');
            if ($data_init_responsive_tabs && $data_init_responsive_tabs.length > 0 && !init) {
                init = true;
                $data_init_responsive_tabs.each(function() {
                    var drop = jquery_min_default()(this);
                    drop.addClass("d-none d-md-flex d-lg-flex d-xl-flex");
                    var content = '<select class="cs-select cs-skin-slide full-width" data-init-plugin="cs-select">';
                    for(var i = 1; i <= drop.children("li").length; i++){
                        var li = drop.children("li:nth-child(" + i + ")");
                        var selected = "";
                        if (li.children("a").hasClass("active")) {
                            selected = "selected";
                        }
                        var tabRef = li.children("a").attr("href");
                        if (tabRef == "#" || "") {
                            tabRef = li.children("a").attr("data-bs-target");
                        }
                        content += '<option value="' + tabRef + '" ' + selected + ">";
                        content += li.children("a").text();
                        content += "</option>";
                    }
                    content += "</select>";
                    drop.after(content);
                    var select = drop.next()[0];
                    jquery_min_default()(select).on("change", function(e) {
                        var optionSelected = jquery_min_default()("option:selected", this);
                        var valueSelected = this.value;
                        var tabLink = drop.find('a[data-bs-target="' + valueSelected + '"]');
                        if (tabLink.length == 0) {
                            tabLink = drop.find('a[data-bs-target="' + valueSelected + '"]');
                        }
                        ;
                        ;
                        ;
                        tabLink.tab("show");
                    });
                    jquery_min_default()(select).wrap('<div class="nav-tab-dropdown cs-wrapper full-width d-lg-none d-xl-none d-md-none"></div>');
                    new SelectFx(select);
                });
            }
        });
    }
// elements.$jumbotron.css('margin-top', elements.$header.height());
});
(function($) {
    $.fn.initHcSticky = function(id, top, sticky) {
        //-------- Only for Desktop --------
        if ($(window).width() > 768 && sticky == null) {
            sticky = new hcSticky(id, {
                top: top
            });
        }
        return sticky;
    };
    $.fn.remToPx = function(rem) {
        return rem / 0.0625;
    };
    $.fn.initElements = function(elements) {
        elements.$window = $(window);
        elements.$header = $("header");
        elements.$jumbotron = $(".jumbotron");
    };
    $.fn.headerFixedToggle = function($window, $header) {
        if ($window.scrollTop() > $header.scrollTop()) {
            $header.removeClass("position-relative");
        } else {
            $header.addClass("position-relative");
        }
    };
    $.fn.headerFixedToggleOnScroll = function($window, $header) {
        $window.scroll(function(action) {
            ;
            $.fn.headerFixedToggle($window, $header);
        });
    };
    $.fn.stickyElement = function($stickyStart, $stickyStop, $stickyElement) {
        var scroll = 0;
        var bottom = 0;
        var $stickyElementTop = $stickyElement.position().top;
        var $stickyElementOuterHeight = $stickyElement.outerHeight(true);
        var $stickyElementParent = $stickyElement.parent();
        //const $stickyStartHeight =  $stickyStart.outerHeight(true) + 30;
        var $stickyStartHeight = 30;
        $.fn.stickyElementConditions(scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop);
        $(window).on("scroll", function(f) {
            $.fn.stickyElementConditions(scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop);
        }).on("resize", function(f) {
            $.fn.stickyElementConditions(scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop);
        });
    };
    $.fn.stickyElementConditions = function(scroll, bottom, $stickyElement, $stickyElementTop, $stickyElementOuterHeight, $stickyElementParent, $stickyStartHeight, $stickyStop) {
        scroll = $(window).scrollTop() + $stickyStartHeight;
        bottom = $(window).scrollTop() + $stickyStartHeight + $stickyElementOuterHeight + 30;
        if ($(window).width() > 991) {
            if (bottom >= $stickyStop.position().top) {
                $stickyElementParent.addClass("d-flex flex-column");
                $stickyElement.removeClass("position-fixed");
                $stickyElement.css("top", "unset");
                $stickyElement.css("margin-top", "auto");
                $stickyElement.css("width", $stickyElementParent.width());
            } else {
                if (scroll >= $stickyElementTop) {
                    $stickyElement.addClass("position-fixed");
                    $stickyElement.css("top", $stickyStartHeight);
                    $stickyElement.css("width", $stickyElementParent.width());
                } else {
                    $stickyElement.removeClass("position-fixed");
                    $stickyElement.css("top", "unset");
                    $stickyElement.css("width", "auto");
                }
                $stickyElement.css("margin-top", "unset");
            }
        } else {
            $stickyElement.removeClass("position-fixed");
            $stickyElement.css("top", "unset");
            $stickyElement.css("width", "auto");
            $stickyElement.css("margin-top", "unset");
        }
    };
})((jquery_min_default())); /**
 * selectFx.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2014, Codrops
 * http://www.codrops.com
 */ 
;
(function(window1) {
    "use strict";
    var hasParent = /**
   * based on from https://github.com/inuyaksa/jquery.nicescroll/blob/master/jquery.nicescroll.js
   */ function hasParent(e, p) {
        if (!e) return false;
        var el = e.target || e.srcElement || e || false;
        while(el && el != p){
            el = el.parentNode || false;
        }
        return el !== false;
    };
    var extend = /**
   * extend obj function
   */ function extend(a, b) {
        for(var key in b){
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    };
    var SelectFx1 = /**
   * SelectFx function
   */ function SelectFx1(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    };
    var closest = /**
   * Pure-JS alternative to jQuery closest()
   */ function closest(elem, selector) {
        var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
        while(elem){
            if (matchesSelector.bind(elem)(selector)) {
                return elem;
            } else {
                elem = elem.parentElement;
            }
        }
        return false;
    };
    var offset = /**
   * jQuery offset() in pure JS
   */ function offset(el) {
        return {
            left: el.getBoundingClientRect().left + window1.pageXOffset - el.ownerDocument.documentElement.clientLeft,
            top: el.getBoundingClientRect().top + window1.pageYOffset - el.ownerDocument.documentElement.clientTop
        };
    };
    var insertAfter = /**
   * jQuery after() in pure JS
   */ function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };
    ;
    /**
   * SelectFx options
   */ SelectFx1.prototype.options = {
        // if true all the links will open in a new tab.
        // if we want to be redirected when we click an option, we need to define a data-link attr on the option of the native select element
        newTab: true,
        // when opening the select element, the default placeholder (if any) is shown
        stickyPlaceholder: true,
        // default container is body
        container: "body",
        // callback when changing the value
        onChange: function onChange(el) {
            var event = document.createEvent("HTMLEvents");
            event.initEvent("change", true, false);
            el.dispatchEvent(event);
        }
    };
    /**
   * init function
   * initialize and cache some vars
   */ SelectFx1.prototype._init = function() {
        // check if we are using a placeholder for the native select box
        // we assume the placeholder is disabled and selected by default
        var selectedOpt = document.querySelector("option[selected]");
        this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;
        // get selected option (either the first option with attr selected or just the first option)
        this.selectedOpt = selectedOpt || this.el.querySelector("option");
        // create structure
        this._createSelectEl();
        // all options
        this.selOpts = [].slice.call(this.selEl.querySelectorAll("li[data-option]"));
        // total options
        this.selOptsCount = this.selOpts.length;
        // current index
        this.current = this.selOpts.indexOf(this.selEl.querySelector("li.cs-selected")) || -1;
        // placeholder elem
        this.selPlaceholder = this.selEl.querySelector("span.cs-placeholder");
        // init events
        this._initEvents();
        this.el.onchange = function() {
            var index = this.selectedIndex;
            var inputText = this.children[index].innerHTML.trim();
        };
    };
    /**
   * creates the structure for the select element
   */ SelectFx1.prototype._createSelectEl = function() {
        var self = this, options = "", createOptionHTML = function createOptionHTML(el) {
            var optclass = "", classes = "", link = "";
            if (el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder) {
                classes += "cs-selected ";
                this.foundSelected = true;
            }
            // extra classes
            if (el.getAttribute("data-class")) {
                classes += el.getAttribute("data-class");
            }
            // link options
            if (el.getAttribute("data-link")) {
                link = "data-link=" + el.getAttribute("data-link");
            }
            if (classes !== "") {
                optclass = 'class="' + classes + '" ';
            }
            return "<li " + optclass + link + ' data-option data-value="' + el.value + '"><span>' + el.textContent + "</span></li>";
        };
        [].slice.call(this.el.children).forEach(function(el) {
            if (el.disabled) {
                return;
            }
            var tag = el.tagName.toLowerCase();
            if (tag === "option") {
                options += createOptionHTML(el);
            } else if (tag === "optgroup") {
                options += '<li class="cs-optgroup"><span>' + el.label + "</span><ul>";
                [].slice.call(el.children).forEach(function(opt) {
                    options += createOptionHTML(opt);
                });
                options += "</ul></li>";
            }
        });
        var opts_el = '<div class="cs-options"><ul>' + options + "</ul></div>";
        this.selEl = document.createElement("div");
        this.selEl.className = this.el.className;
        this.selEl.tabIndex = this.el.tabIndex;
        this.selEl.innerHTML = '<span class="cs-placeholder">' + this.selectedOpt.textContent + "</span>" + opts_el;
        this.el.parentNode.appendChild(this.selEl);
        this.selEl.appendChild(this.el);
        // backdrop to support dynamic heights of the dropdown
        var backdrop = document.createElement("div");
        backdrop.className = "cs-backdrop";
        this.selEl.appendChild(backdrop);
    };
    /**
   * initialize the events
   */ SelectFx1.prototype._initEvents = function() {
        var self = this;
        // open/close select
        this.selPlaceholder.addEventListener("click", function() {
            self._toggleSelect();
        });
        // clicking the options
        this.selOpts.forEach(function(opt, idx) {
            opt.addEventListener("click", function() {
                self.current = idx;
                self._changeOption();
                // close select elem
                self._toggleSelect();
            });
        });
        // close the select element if the target it´s not the select element or one of its descendants..
        document.addEventListener("click", function(ev) {
            var target = ev.target;
            if (self._isOpen() && target !== self.selEl && !hasParent(target, self.selEl)) {
                self._toggleSelect();
            }
        });
        // keyboard navigation events
        this.selEl.addEventListener("keydown", function(ev) {
            var keyCode = ev.keyCode || ev.which;
            switch(keyCode){
                // up key
                case 38:
                    ev.preventDefault();
                    self._navigateOpts("prev");
                    break;
                // down key
                case 40:
                    ev.preventDefault();
                    self._navigateOpts("next");
                    break;
                // space key
                case 32:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != "undefined" && self.preSelCurrent !== -1) {
                        self._changeOption();
                    }
                    self._toggleSelect();
                    break;
                // enter key
                case 13:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != "undefined" && self.preSelCurrent !== -1) {
                        self._changeOption();
                        self._toggleSelect();
                    }
                    break;
                // esc key
                case 27:
                    ev.preventDefault();
                    if (self._isOpen()) {
                        self._toggleSelect();
                    }
                    break;
            }
        });
    };
    /**
   * navigate with up/dpwn keys
   */ SelectFx1.prototype._navigateOpts = function(dir) {
        if (!this._isOpen()) {
            this._toggleSelect();
        }
        var tmpcurrent = typeof this.preSelCurrent != "undefined" && this.preSelCurrent !== -1 ? this.preSelCurrent : this.current;
        if (dir === "prev" && tmpcurrent > 0 || dir === "next" && tmpcurrent < this.selOptsCount - 1) {
            // save pre selected current - if we click on option, or press enter, or press space this is going to be the index of the current option
            this.preSelCurrent = dir === "next" ? tmpcurrent + 1 : tmpcurrent - 1;
            // remove focus class if any..
            this._removeFocus();
            // add class focus - track which option we are navigating
            classie_min_default().add(this.selOpts[this.preSelCurrent], "cs-focus");
        }
    };
    /**
   * open/close select
   * when opened show the default placeholder if any
   */ SelectFx1.prototype._toggleSelect = function() {
        var backdrop = this.selEl.querySelector(".cs-backdrop");
        var container = document.querySelector(this.options.container);
        var mask = container.querySelector(".dropdown-mask");
        var csOptions = this.selEl.querySelector(".cs-options");
        var csPlaceholder = this.selEl.querySelector(".cs-placeholder");
        var csPlaceholderWidth = csPlaceholder.offsetWidth;
        var csPlaceholderHeight = csPlaceholder.offsetHeight;
        var csOptionsWidth = csOptions.scrollWidth;
        if (this._isOpen()) {
            if (this.current !== -1) {
                // update placeholder text
                this.selPlaceholder.textContent = this.selOpts[this.current].textContent;
            }
            var dummy = this.selEl.data;
            var parent = dummy.parentNode;
            //parent.appendChild(this.selEl);
            insertAfter(this.selEl, dummy);
            this.selEl.removeAttribute("style");
            parent.removeChild(dummy);
            // Hack for FF
            // http://stackoverflow.com/questions/12088819/css-transitions-on-new-elements
            var x = this.selEl.clientHeight;
            // reset backdrop
            backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = "scale3d(1,1,1)";
            classie_min_default().remove(this.selEl, "cs-active");
            mask.style.display = "none";
            csOptions.style.overflowY = "hidden";
            csOptions.style.width = "auto";
            var parentFormGroup = closest(this.selEl, ".form-group");
            parentFormGroup && classie_min_default().removeClass(parentFormGroup, "focused");
        } else {
            if (this.hasDefaultPlaceholder && this.options.stickyPlaceholder) {
                // everytime we open we wanna see the default placeholder text
                this.selPlaceholder.textContent = this.selectedOpt.textContent;
            }
            var dummy;
            if (this.selEl.parentNode.querySelector(".dropdown-placeholder")) {
                dummy = this.selEl.parentNode.querySelector(".dropdown-placeholder");
            } else {
                dummy = document.createElement("div");
                classie_min_default().add(dummy, "dropdown-placeholder");
                //this.selEl.parentNode.appendChild(dummy);
                insertAfter(dummy, this.selEl);
            }
            dummy.style.height = csPlaceholderHeight + "px";
            dummy.style.width = this.selEl.offsetWidth + "px";
            this.selEl.data = dummy;
            this.selEl.style.position = "absolute";
            var offsetselEl = offset(this.selEl);
            this.selEl.style.left = offsetselEl.left + "px";
            this.selEl.style.top = offsetselEl.top + "px";
            container.appendChild(this.selEl);
            // decide backdrop's scale factor depending on the content height
            var contentHeight = csOptions.offsetHeight;
            var originalHeight = csPlaceholder.offsetHeight;
            var contentWidth = csOptions.offsetWidth;
            var originalWidth = csPlaceholder.offsetWidth;
            var scaleV = contentHeight / originalHeight;
            var scaleH = contentWidth > originalWidth ? contentWidth / originalWidth : 1.05;
            //backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(' + scaleH + ', ' + scaleV + ', 1)';
            backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = "scale3d(" + 1 + ", " + scaleV + ", 1)";
            if (!mask) {
                mask = document.createElement("div");
                classie_min_default().add(mask, "dropdown-mask");
                container.appendChild(mask);
            }
            mask.style.display = "block";
            classie_min_default().add(this.selEl, "cs-active");
            var resizedWidth = csPlaceholderWidth < csOptionsWidth ? csOptionsWidth : csPlaceholderWidth;
            this.selEl.style.width = resizedWidth + "px";
            this.selEl.style.height = originalHeight + "px";
            csOptions.style.width = "100%";
            setTimeout(function() {
                csOptions.style.overflowY = "auto";
            }, 300);
        }
    };
    /**
   * change option - the new value is set
   */ SelectFx1.prototype._changeOption = function() {
        // if pre selected current (if we navigate with the keyboard)...
        if (typeof this.preSelCurrent != "undefined" && this.preSelCurrent !== -1) {
            this.current = this.preSelCurrent;
            this.preSelCurrent = -1;
        }
        // current option
        var opt = this.selOpts[this.current];
        // update current selected value
        this.selPlaceholder.textContent = opt.textContent;
        // change native select element´s value
        this.el.value = opt.getAttribute("data-value");
        // remove class cs-selected from old selected option and add it to current selected option
        var oldOpt = this.selEl.querySelector("li.cs-selected");
        if (oldOpt) {
            classie_min_default().remove(oldOpt, "cs-selected");
        }
        classie_min_default().add(opt, "cs-selected");
        // if there´s a link defined
        if (opt.getAttribute("data-link")) {
            // open in new tab?
            if (this.options.newTab) {
                window1.open(opt.getAttribute("data-link"), "_blank");
            } else {
                window1.location = opt.getAttribute("data-link");
            }
        }
        // callback
        this.options.onChange(this.el);
    };
    /**
   * returns true if select element is opened
   */ SelectFx1.prototype._isOpen = function(opt) {
        return classie_min_default().has(this.selEl, "cs-active");
    };
    /**
   * removes the focus class from the option
   */ SelectFx1.prototype._removeFocus = function(opt) {
        var focusEl = this.selEl.querySelector("li.cs-focus");
        if (focusEl) {
            classie_min_default().remove(focusEl, "cs-focus");
        }
    };
    /**
   * add to global namespace
   */ window1.SelectFx = SelectFx1;
})(window);

;// CONCATENATED MODULE: ./components/PropertyScripts.tsx


function IndexScripts() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


/***/ })

}]);